import e from"graphql-tag";var t,n,r,a,T;!function(e){e.AfterResolverType="AFTER_RESOLVER",e.BeforeResolverType="BEFORE_RESOLVER",e.ValidationType="VALIDATION"}(t||(t={})),function(e){e.ApprovalType="APPROVAL",e.AssetTypeType="ASSET_TYPE",e.CompanyTypeType="COMPANY_TYPE",e.DocumentType="DOCUMENT",e.DrawingType="DRAWING",e.OrganizationChannelType="ORGANIZATION_CHANNEL",e.PhotoType="PHOTO",e.ProductTypeType="PRODUCT_TYPE",e.PublicationChannelType="PUBLICATION_CHANNEL",e.RegionRelevanceType="REGION_RELEVANCE",e.SoftwareType="SOFTWARE",e.VideoType="VIDEO"}(n||(n={})),function(e){e.CustomerSpecificType="CUSTOMER_SPECIFIC",e.EmptyType="EMPTY",e.InternalType="INTERNAL",e.PublicType="PUBLIC"}(r||(r={})),function(e){e.ArchivedType="ARCHIVED",e.PublishedType="PUBLISHED"}(a||(a={})),function(e){e.ArchivedType="ARCHIVED",e.PublishedType="PUBLISHED"}(T||(T={}));const p=e`
  query cfhsMetadata {
    cfhsMetadata {
      id
      name
      slugPath
      path
    }
  }
`,i=e`
  query productsByIdsInFinder($ids: [String!]!) {
    productsById(ids: $ids) {
      id
      headline
      brand
      subBrand
      exclusiveToOtherCustomers
    }
  }
`,s=(e,t,n,r)=>e();function y(e,t=s){return{cfhsMetadata:(n,r,a)=>t((t=>e.request({document:p,variables:n,requestHeaders:{...r,...t},signal:a})),"cfhsMetadata","query",n),productsByIdsInFinder:(n,r,a)=>t((t=>e.request({document:i,variables:n,requestHeaders:{...r,...t},signal:a})),"productsByIdsInFinder","query",n)}}export{t as ApplyPolicyType,p as CfhsMetadataDocumentType,n as DamDefinitionTypeType,i as ProductsByIdsInFinderDocumentType,r as ProductsVisibilityType,a as SoftwareStatusType,T as VisualStatusType,y as getSdk};
